import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import Dashboard from '~/pages/Dashboard';
import SignIn from '~/pages/SignIn';
import Lenders from '~/pages/Lenders';

const routes: React.FC = () => {
  return (
    <Switch>
      <Route path={`${process.env.PUBLIC_URL}/`} exact component={SignIn} />
      <Route
        path={`${process.env.PUBLIC_URL}/dashboard`}
        exact
        component={Dashboard}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/lenders`}
        exact
        component={Lenders}
        isPrivate
      />
    </Switch>
  );
};

export default routes;
